import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Study } from 'src/app/data/study';
import { AlertService } from 'src/app/services/alert.service';
import { BookService } from 'src/app/services/book.service';
import { ConfigService } from 'src/app/services/config.service';
import { StudiesService } from 'src/app/services/studies.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-download-modal',
  templateUrl: './download-modal.component.html',
  styleUrls: ['./download-modal.component.css']
})
export class DownloadModalComponent implements OnInit{

  @Input() opened = false;
  @Input() bookStudies;
  firstModal: boolean = true;
  //@Output('sendMail') sendMailEmitter = new EventEmitter<string>();

  @Output('downloadStudy') downloadStudyEmitter = new EventEmitter<void>();

  constructor(
    private alertService: AlertService,
    public bookService: BookService,
    public studiesService: StudiesService,
    public configService: ConfigService,
    public http: HttpClient
  ) { }

  ngOnInit(): void {
  }

  open() {
    console.log(this.bookService.currentBookReports);
    if(this.bookService.currentBook != null){
      if( this.bookService.currentBookReports == null || this.bookService.currentBookReports.length == 0){
        this.firstModal = false;
      }

      this.opened = true;
    }else{
      console.error('currentBook is null');
    }
  }

  close() {
    this.opened = false;
  }

  changeModal(){
    this.firstModal = false;
  }

  closeSecondModal(){
    if( this.bookService.currentBookReports == null || this.bookService.currentBookReports.length == 0){
      this.close();
    }else{
      this.firstModal = true;
    }
  }

  downloadDicom(){

    this.downloadStudyEmitter.emit();
    this.firstModal = true;
    this.close();
  }

  downloadReport(){
    
    this.studiesService.downloadReport(this.bookService.currentBook!.studyUIDs);
    
  }

  printReport() {

    if (!environment.demo) {
      const url = `${this.configService.syncBOOK_URL}/bookAccess/getReportBytesByStudyUID`;
      this.http.post(url, this.bookService.currentBook!.studyUIDs, { withCredentials: true, responseType: 'arraybuffer' }).subscribe(reportBytes => {
        // console.log('reportBytes', reportBytes);
        if (reportBytes == null || reportBytes.byteLength == 0) {
          this.alertService.alert('Este estudio no dispone de informe. Póngase en contacto con el centro para más información')
        } else {
          const blob = new Blob([reportBytes], { type: 'application/pdf' });
          const blobUrl = URL.createObjectURL(blob);
          this.studiesService.printBlob(blobUrl);

        }
      }, error => this.alertService.alert('No se ha podido descargar el informe. Por favor, actualice la página e inténtelo de nuevo más tarde'))
    } else {
      const url = 'assets/demo/report.pdf';
      this.studiesService.printBlob(url);
    }
  }

  

}
